import React from 'react';
export const CameraIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.25 10.5V12.75H1.75V4.25H10.25V6.5V8L11.45 7.1L13.85 5.3C14.0148 5.17639 14.25 5.29399 14.25 5.5V11.5C14.25 11.706 14.0148 11.8236 13.85 11.7L11.45 9.9L10.25 9V10.5Z"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
